import { useImpersonationStore } from "../../../stores/useImpersonationStore";

/**
 * Spec 030 — Banner fijo global de sesión de soporte. Montado en el wrapper
 * autenticado de App.tsx (no dentro de MenuWrapper). Solo se muestra cuando hay
 * una impersonación activa; los usuarios normales nunca lo ven (FR-016).
 */
const BAR_HEIGHT = 40;

const ImpersonationBanner = () => {
  const active = useImpersonationStore((s) => s.active);
  const businessName = useImpersonationStore((s) => s.businessName);
  const exit = useImpersonationStore((s) => s.exit);

  if (!active) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: BAR_HEIGHT,
          zIndex: 100000,
          background: "#b91c1c",
          color: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          fontFamily: "Mulish, system-ui, sans-serif",
          fontSize: "0.85rem",
          fontWeight: 700,
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        }}
        role="status"
      >
        <span>
          Estás viendo <strong>{businessName}</strong> como soporte de Prikly
        </span>
        <button
          onClick={exit}
          style={{
            background: "#ffffff",
            color: "#b91c1c",
            border: "none",
            borderRadius: 999,
            padding: "0.25rem 0.85rem",
            fontWeight: 800,
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: "0.8rem",
          }}
        >
          Salir
        </button>
      </div>
      {/* Empuja el contenido para no tapar el navbar bajo la barra fija. */}
      <div style={{ height: BAR_HEIGHT }} aria-hidden="true" />
    </>
  );
};

export default ImpersonationBanner;
